import { render, staticRenderFns } from "./PhoneDialog.vue?vue&type=template&id=e4a6b6a0&scoped=true"
import script from "./PhoneDialog.vue?vue&type=script&lang=js"
export * from "./PhoneDialog.vue?vue&type=script&lang=js"
import style0 from "./PhoneDialog.vue?vue&type=style&index=0&id=e4a6b6a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a6b6a0",
  null
  
)

export default component.exports